<template>
    <v-container>
        <v-layout
        text-xs-center
        wrap> 
        <v-flex md8 xs12 offset-md2 justify-center>
                <v-layout text-xs-center wrap>
                     <v-flex xs12 md8 offset-md2>
                         <img src="../assets/yh-logo.png" width="300px" class="img-align"><br>
                         <h2 class="font-weight-light" v-html="text.head"></h2><br>
                        <h3 class="font-weight-light">กรุณากรอกเบอร์โทรศัพท์</h3>                  
                        <masked-input  class="telBox" v-model="telNum" mask="11-1111-1111" placeholder="08-XXXX-XXXX" @input="search"/>
                        <!-- <router-link to="/report">Report</router-link> -->
                </v-flex>
                </v-layout>
        </v-flex>
        </v-layout>

        <v-layout
        text-xs-center
        wrap> 
         <v-flex md8 xs12 offset-md2 v-if="telNum[11] !== '_' && telNum !== ''">
                <div v-if="data.length < 1" >
                    <!-- <h3 class="font-weight-light">ขอแสดงความเสียใจด้วยครับ</h3> -->
                    <img src="../assets/sorry.png" width="400px" class="img-align">
                    <!-- <h4 class="font-weight-light">ทางทีมงานขอขอบคุณที่ท่านให้ความสนใจ <br> ในการสมัครงานครั้งนี้ <br><br>
                    ทางโฮมโปรพิจารณาแล้ว <br> ในครั้งนี้ ท่านไม่ผ่านการคัดเลือก <br>
                    โปรดติดตาม การรับสมัครงานในครั้งต่อไป <br> ในแอพยังแฮปปี้
                    </h4> -->
                    <h4 class="font-weight-light" v-html="text.reject_text">
                    </h4>
                    <br><br><br>
                </div>
                <div v-if="data.length >= 1">
                    <!-- <h3 class="font-weight-light">ขอแสดงความยินดีด้วยค่ะ</h3> -->
                    <img src="../assets/congrat.png" width="400px" class="img-align">
                    <h1 class="font-weight-light">{{data[0].name}} {{data[0].lastName}}</h1>
                    <!-- <h4 class="font-weight-light">ได้รับสิทธิ์ในการสัมภาษณ์งานกับ Homepro</h4> -->
                    <h4 class="font-weight-light" v-html="text.accept_text"></h4>
                    <h4 class="font-weight-light" v-html="data[0].round"></h4>
                    <h4 class="font-weight-light" v-if="data[0].time !== ''">{{data[0].time}}</h4><br>
                    <h4 class="font-weight-light" >กรุณากดปุ่ม "ยืนยันเข้าร่วม" หรือ "ไม่เข้าร่วม"</h4>

                    <v-layout v-if="data[0].status == null">
                        <v-flex text-xs-right>
                            <v-btn color="#97c763"  @click="updateStatus(true)" :disabled="disable">ยืนยันเข้าร่วม</v-btn>
                        </v-flex>
                        <v-flex text-xs-left>
                            <v-btn color="#97c763"  @click="updateStatus(false)" :disabled="disable">ไม่เข้าร่วม</v-btn>
                        </v-flex>
                    </v-layout>

                    <v-layout v-if="data[0].status == true" justify-center>
                        ยืนยันเข้าร่วม
                    </v-layout> 

                    <v-layout v-if="data[0].status == false" justify-center>
                        ขอยกเลิก
                    </v-layout> 

                    <br><hr> <br>

                </div>
        </v-flex>
        </v-layout>

        <v-layout
        wrap> 
         <v-flex md8 xs12 offset-md2 text-xs-center>
                <div v-if="data.length >= 1">
                    <h4 class="font-weight-light" >{{text.date}} {{text.time}}</h4>
                    <h4 class="font-weight-light">{{text.location}}</h4>
                    <br><br><br><br>
                </div>
        </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import firebase from 'firebase'
import MaskedInput from 'vue-masked-input' 
export default {
    components: { 
        MaskedInput 
    },
    data () {
        return {
            telNum: "",
            user: [],
            success: false,
            data: {},
            text: {},
            textTest: "",
            temp: {},
            telTemp: '',
            disable: false
        }
    },
    created () {
        let id = this.$route.params.id
        console.log(id)
    },
    mounted () {
        this.getAllData()
    },
    methods: {
        search() {
            let [first,sec,third] = this.telNum.split('-')
            this.telTemp = first+sec+third
            // console.log(this.telTemp)
            this.data = this.user.filter(e => {
                return e.tel === this.telTemp
            })
        },searchTel(tel) {
            this.data = this.user.filter(e => {
                return e.tel === this.tel
            })
        },
        updateStatus(status) {
            this.$swal("ยืนยันการทำรายการ", {
            buttons: {
                cancel: "ยกเลิก",
                save: {
                    text: "ตกลง",
                    value: "save",
                },
            },
            })
            .then((value) => {
                switch (value) {
                    case "save":
                    this.disable = true
                    firebase.database().ref('/all/'+this.$route.params.id+'/data').child(this.data[0].key).update({
                        status: status,
                    }).then(e => {
                        // this.temp = this.getDataByKey(this.data[0].key)
                        // this.searchTel(this.telTemp)
                        swal("เรียบร้อย!", "บันทึกข้อมูลเรียบร้อย", "success");
                    })
                    break;
                    case "cancel":
                    break;
                }
            });
        },
        getAllData() {
            const db = firebase.database().ref('/all/'+this.$route.params.id+'/data').once('value', (data) => {
                data.forEach(e => {
                    let user = e.child('tel').val()
                    let interviewTime = ''
                    if (e.child('interviewTime').val() === 'รอบเช้า') {
                        interviewTime = 'วันที่ 14 ธ.ค. 2561 รอบเช้า เวลา 10.00-12.00 น.'
                    } else if (e.child('interviewTime').val() === 'รอบบ่าย') {
                        interviewTime = 'วันที่ 14 ธ.ค. 2561 รอบบ่าย เวลา 13.00-16.00 น.'
                    }
            
                    let temp = {
                        name: e.child('name').val(),
                        lastName: e.child('lastName').val(),
                        tel: e.child('tel').val(),
                        fullName: e.child('name').val() + ' '+ e.child('lastName').val(),
                        age: e.child('age').val(),
                        email: e.child('email').val(),
                        address: e.child('address').val(),
                        position: e.child('position').val(),
                        experience: e.child('experience').val(),
                        hasExp: e.child('hasExperience').val(),
                        canShiftWork: e.child('canShiftWork').val(),
                        health: e.child('health').val(),
                        disease: e.child('disease').val(),
                        potential: e.child('potential').val(),
                        education: e.child('education').val(),
                        other: e.child('other').val(),
                        branch: e.child('branch').val(),
                        productBought: e.child('productBought').val(),
                        carreerHistory: e.child('carreerHistory').val(),
                        inspiration: e.child('inspiration').val(),
                        interviewTime: interviewTime,
                        time: e.child('time').val(),
                        status: e.child('status').val(),
                        key: e.key,
                        round: e.child('round').val()
                    }
                    this.user.push(temp)
                })
            })

            const db2 = firebase.database().ref('/all/'+this.$route.params.id+'/text').once('value', (data) => {
                var wrapper= document.createElement('br');
                // wrapper.innerHTML = "<br>"
                let tempText = data.child('head').val()
                let temp = {
                        accept_text: data.child('accept_text').val(),
                        reject_text: data.child('reject_text').val(),
                        date: data.child('date').val(),
                        time: data.child('time').val(),
                        head: tempText,
                        location: data.child('location').val(),
                    }
                    this.text = temp
            })
        },
        getDataByKey(key) {
             const db = firebase.database().ref('/all/'+this.$route.params.id+'/data').child(key).once('value', (e) => {
                 let temp = {
                        name: e.child('name').val(),
                        lastName: e.child('lastName').val(),
                        tel: e.child('tel').val(),
                        fullName: e.child('name').val() + ' '+ e.child('lastName').val(),
                        age: e.child('age').val(),
                        email: e.child('email').val(),
                        address: e.child('address').val(),
                        position: e.child('position').val(),
                        experience: e.child('experience').val(),
                        hasExp: e.child('hasExperience').val(),
                        canShiftWork: e.child('canShiftWork').val(),
                        health: e.child('health').val(),
                        disease: e.child('disease').val(),
                        potential: e.child('potential').val(),
                        education: e.child('education').val(),
                        other: e.child('other').val(),
                        branch: e.child('branch').val(),
                        productBought: e.child('productBought').val(),
                        carreerHistory: e.child('carreerHistory').val(),
                        inspiration: e.child('inspiration').val(),
                        time: e.child('time').val(),
                        status: e.child('status').val(),
                        key: e.key
                    }
                    return temp
            })
        }
    },
    computed: {
        result () {
            return this.user.filter(e => {
                return e.tel.includes(this.telNum)
            })
        }
    },
    watch: {
        data (newVal, oldVal) {
            // console.log(newVal, oldVal)
        }
    }
    
}
</script>

<style>

.telBox {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
  text-align: center;
  background-color: #f8f8f8;
  font-size: 18px;
  border-radius: 4px;
  border: 2px solid #ccc;
}

.block {
    background-color: lightgray;
    opacity: 50%;
}

</style>
